export function createElement(tag, { id = "", classes = [], attributes = {} } = {}) {
  const el = document.createElement(tag);

  // Set the ID if provided
  if (id) {
    el.id = id;
  }

  // Add classes if provided
  if (Array.isArray(classes)) {
    classes.forEach((cls) => el.classList.add(cls));
  } else if (typeof classes === "string") {
    // In case the user passes a single string
    el.classList.add(classes);
  }

  // Set other attributes
  for (const [attr, value] of Object.entries(attributes)) {
    el.setAttribute(attr, value);
  }

  return el;
}
